import React, { useState } from "react";
import Button from "../../../../Components/Common/Button/Button";
import PhoneInput from "../../../../Components/Common/PhoneInput/PhoneInput";
import Input from "../../../../Components/Common/Input/Input";

interface SubcontractorForm {
  name: string;
  email: string;
  phone: string;
  amount: string;
}

interface AddSubcontractorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (payload: SubcontractorForm) => void;
}

const AddSubcontractorModal = ({
  isOpen,
  onClose,
  onSubmit,
}: AddSubcontractorModalProps) => {
  const [form, setForm] = useState<SubcontractorForm>({
    name: "",
    email: "",
    phone: "",
    amount: "",
  });

  const handleChange = (key: keyof SubcontractorForm, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    if (!form.name.trim()) return;
    onSubmit(form);
    setForm({ name: "", email: "", phone: "", amount: "" });
  };

  return (
    <div
      className={`modalOverlay ${isOpen ? "open" : ""}`.trim()}
      role="dialog"
      aria-modal="true"
      aria-hidden={!isOpen}
      aria-labelledby="add-sub-title"
    >
      <div className="subModal">
        <h3 className="modalTitle" id="add-sub-title">
          Add Subcontractor
        </h3>

        <div className="field">
          <Input
            id="modal-name"
            label="Company Name *"
            value={form.name}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("name", event.target.value)
            }
            placeholder="e.g. Smith Electrical LLC"
            type="text"
          />
        </div>

        <div className="field">
          <Input
            id="modal-email"
            label="Email Address"
            value={form.email}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("email", event.target.value)
            }
            placeholder="contact@company.com"
            type="email"
          />
        </div>

        <div className="field">
          <label htmlFor="modal-phone">Mobile / SMS Number</label>
          <PhoneInput
            value={form.phone}
            onChange={(value) => handleChange("phone", value)}
          />
        </div>

        <div className="field">
          <Input
            id="modal-amount"
            label="Amount Being Paid This Draw"
            value={form.amount}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("amount", event.target.value)
            }
            placeholder="$0.00"
            type="text"
          />
        </div>
        <div className="field">
          <Input
            label="Amount Being Paid This Draw"
            value={form.amount}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("amount", event.target.value)
            }
            placeholder="$0.00"
            type="number"
          />
        </div>

        <div className="modalActions">
          <Button className="btn btnSecondary" onClick={onClose}>
            Cancel
          </Button>
          <Button className="btn btnPrimary" onClick={handleSubmit}>
            Add &amp; Send Waiver
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddSubcontractorModal;
